module.exports = __webpack_public_path__ + "static/img/wep.1551226.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/WZBankMin/wep.png
// module id = D0Lt
// module chunks = 70